import "./UsersInteractions.css";
import React, { useState, useMemo, useEffect } from "react";
import Selector from "components/Selector/Selector";
import { t } from "i18next";
import CustomTimeline from "components/CustomTimeline/CustomTimeline";
import Search from "components/Inputs/Search/Search";
import NoData from "components/NoData/NoData";
import Spinner from "components/Spinner/Spinner";
import { formatDate } from "helperFunctions/date";

interface EventHistoryProps {
  eventHistory: Record<string, { el: Array<EventData> }>;
  filterComponent?: React.ReactNode;
  loading?: boolean; 

}

interface EventData {
  k: string;
  t: number;
  p: number;
  segment: Record<string, string>;
}

const UserInteractions: React.FC<EventHistoryProps> = ({ eventHistory,filterComponent,loading }) => {
  const [selectedDid, setSelectedDid] = useState<string | null>(null);
  const [didOptions, setDidOptions] = useState<{ value: string; label: string }[]>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch did options directly from eventHistory keys when component mounts
  useEffect(() => {
    if (!eventHistory || Object.keys(eventHistory).length === 0) {
      setDidOptions([]);
      setSelectedDid(null);
      return;
    }
    const didEventOptions = Object?.keys(eventHistory)?.map((did) => ({
      value: did,
      label: did,
    }));
    setDidOptions(didEventOptions);
    const didValue = Object.entries(eventHistory).find(([key, { el }]) => el?.length);
    if (didValue) {
        const [key] = didValue;
        setSelectedDid(key);
      }
    else{
     setSelectedDid(didEventOptions[0]?.value)
    }
   
  }, [eventHistory]);
 
 
  // Memoize the modified event data for the selected DID
  const modifiedEventData = useMemo(() => {
    if (selectedDid) {
      return eventHistory[selectedDid]?.el
        ?.sort((a, b) => b.p - a.p) // Sort in descending order based on `p`
        ?.map((event) => {
          const availableString = Object.entries(event.segment || {})
            .map(([key, value]) => `${key}:${value}`)
            .join(", ");

          return {
            label: formatDate(event.p,"DD/MM/YY:HH:mm:ss"),
            children: `${event.k}, ${availableString}`,
          };
        });
    }
    return [];
  }, [selectedDid, eventHistory]);
  const filteredEventData = useMemo(() => {
    if (!searchQuery) return modifiedEventData;
    return modifiedEventData?.filter((item) =>
      (item.label + " " + item.children).toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [modifiedEventData, searchQuery]);
  return (
    <div className="user-interactions-main-container">
              <h6 className="m-2">{t("usersInterctionsLabel")}</h6>

      <div className=" mt-2 d-flex justify-content-between align-items-baseline">
        <Search
            
              placeholder={`${t("searchLabel")}`}
              className="input-size-lg my-2 me-2"
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
          />
        
            {filterComponent}
      </div>
      <div className="my-2 border-top pt-2 user-interactions-events-width">
        <Selector
          className="input-size-xlg"
          placeholder="Select DID"
          options={didOptions}
          value={selectedDid} // Set the current value
          onChange={(value) => setSelectedDid(value)} // Update the selected DID
          showCopyIcon
        />
      </div>
      
        <div className="p-4 user-interactions-timeline-wrapper" >
          <div className="m-2 mb-4">
            <h6>{t("behaviouralDataLabel")}</h6>
          </div>
          {loading ?<Spinner/>:<>
          {filteredEventData && filteredEventData?.length > 0 ? (
            <div> 
            <div className="d-flex">
            <CustomTimeline mode="left" layout="event" items={filteredEventData} />
            </div>
            </div>
        ) : (
            <div>
            <NoData />
            </div>
        )}   
        </>}
        </div>
  
    </div>
  );
};

export default UserInteractions;
